import { withRouter } from "react-router-dom";
import {ROUTES} from "../../constants";


function PresentationRoute({location}) {
    window.location.href = `${window.location.protocol}//${window.location.host}${ROUTES.QUIZ.METEOR_PREFIX}${location.pathname}`;
    return <div>
    </div>
}
export default withRouter(PresentationRoute);
